import React  from 'react';
import AboutDetail from "../AboutDetail"; // we need this to make JSX compile

const TheComponent = ({}) => {
    return (
        <div>
            <AboutDetail/>
        </div>
    )
}

export default TheComponent
